import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// filepath: /D:/xamp8.2/htdocs/chaseit1416/resources/js/Pages/components/Schedule.tsx
import React from "react";
import PageHeader from "../../components/PageHeader";
import useChaseListNavigate from "../../hooks/useChaseListNavigate";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { MenuOption } from "../../components/MenuOption";
import ReorderIcon from '@mui/icons-material/Reorder';
var WorkOrder = function () {
    var chaseListNavigate = useChaseListNavigate();
    var pageChangeHandle = function (path, isExternal) {
        if (isExternal === void 0) { isExternal = false; }
        if (isExternal) {
            window.open(path, '_blank');
            return;
        }
        chaseListNavigate(path);
    };
    var today = (moment().format("YYYY-MM-DD"));
    var tomorrow = (moment().add(1, 'days').format("YYYY-MM-DD"));
    return (_jsxs("div", { children: [_jsx(PageHeader, { pageTitle: "Work Order" }), _jsxs("div", { className: "flex-1 overflow-y-auto custom-content-height px-[18px] py-[18px] bg-[#F7F7F7]", children: [_jsx(MenuOption, { iconComponent: _jsx(ReorderIcon, { style: { color: '#5898fd' } }), label: "Today's Daily Ship Order", hasArrow: true, onClick: function () { return pageChangeHandle("https://ilalocal1416.my.salesforce-sites.com/ILADailyShipOrder?OrderDate=".concat(today), true); } }), _jsx(MenuOption, { iconComponent: _jsx(ReorderIcon, { style: { color: '#5898fd' } }), label: "Tomorrow's Daily Ship Order", hasArrow: true, onClick: function () { return pageChangeHandle("https://ilalocal1416.my.salesforce-sites.com/ILADailyShipOrder?OrderDate=".concat(tomorrow), true); } })] })] }));
};
export default WorkOrder;
